module.exports = __webpack_public_path__ + "img/paint_icon.ba9a1d03.svg";